module.exports = __webpack_public_path__ + "static/image/MK.svg?7cbb274c8ef48cd18e217e1894c55317";